export default __webpack_public_path__ + "96db0b1c0dd0f81ec5863c6c1fa77a41.png";